import type { FeaturePurchaseOfferDefinition } from "@slot/game-shell";

/**
 * The game's 2 features (ids are the server contract — they ride SpinRequest verbatim):
 *   bonus_buy ("requestedFeatureIdentifier"):
 *     - super_bonus_buy — buy straight into the free-spins round.
 *   feature_mode ("requestedFeatureModeIdentifier", persistent per-spin modes — one active at a time):
 *     - bonus_hunt_mode — higher free-spins trigger chance.
 * Prices come from initialSettings (featurePriceMultipliersById / featureModeMultipliersById).
 */
export function createFeaturePurchaseOffers(): FeaturePurchaseOfferDefinition[] {
  return [
    {
      id: "super_bonus_buy",
      actionType: "bonus_buy",
      titleKey: "feature_purchase.super_bonus_buy.title",
      descriptionKey: "feature_purchase.super_bonus_buy.description",
      fallbackTitle: "Bonus Buy",
      fallbackDescription: "Buy your way straight into the free-spins round.",
      iconPath: "feature-purchase/icons/free_spins/spriteFrame",
    },
    {
      id: "bonus_hunt_mode",
      actionType: "feature_mode",
      titleKey: "feature_purchase.bonus_hunt_mode.title",
      descriptionKey: "feature_purchase.bonus_hunt_mode.description",
      fallbackTitle: "Bonushunt Featurespins",
      fallbackDescription: "Each spin is more likely to trigger a bonus game.",
      iconPath: "feature-purchase/icons/super_bonus/spriteFrame",
    },
  ];
}